/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { Link } from 'react-router-dom'
import { Delete_Document } from '../Edit_Propetry/Edit_Propetry_Api'
import Swal from 'sweetalert2'

type Props = {
  icon: string
  property_document_uuid?: string
  getDoc?: any
  title: string
  description: string
  link: string
}

const CardNew: FC<Props> = ({ icon, property_document_uuid, getDoc, title, description, link }) => {
  const handleDeleteDocument = async (property_document_uuid: string) => {
    Swal.fire({
      title: 'Are you sure you want to archive this document?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { data: res } = await Delete_Document(
            property_document_uuid
          )
          if (res.code === '200') {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
              text: res.msg_details,
              allowOutsideClick: true,
            })
            getDoc()
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
              text: res.msg_details,
              allowOutsideClick: true,
            })
          }
        }
        catch (error: any) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error',
            text: error,
            allowOutsideClick: true,
          })
        }
      }
    })
  }
  return (
    <div className='card h-110px shadow-sm' title={description}>
      <div className='d-flex justify-content-center text-center flex-column w-100'>
        <div className='text-gray-800 d-flex flex-column py-2 rounded-top'>
          <div className='symbol symbol-75px mb-4'>
            <img src={toAbsoluteUrl(icon)} alt='Docs' className='h-30px w-30px' />
          </div>
          <div className='fs-5 fw-bold mb-2 text-truncate'>{title}</div>
        </div>
        {/* <div className='fs-7 fw-bold text-gray-400 mt-auto'>{description}</div> */}
        
        <div className='row w-100 m-0 justify-content-center'>
          <Link
            to={link}
            target="_blank"
            className={`border border-secondary p-0 h-30px btn btn-light btn-sm ${property_document_uuid? 'col-6': 'col-12'} rounded-0 rounded-bottom image_icon`}
            title='Download'
          >
            <i className='bi bi-download text-primary fa-md fs-2'></i>
          </Link>
          {
            property_document_uuid && <button
              className='border border-secondary p-0 h-30px btn btn-light btn-sm col-6 rounded-0 rounded-bottom image_icon'
              title='Archive'
              onClick={() => handleDeleteDocument(property_document_uuid ? property_document_uuid : "")}
            >
              <i className='bi bi-trash text-danger fa-md fs-2'></i>
            </button>
          }

        </div>
      </div>
    </div>
  )
}

export { CardNew }
